import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { httpClient } from "@/shared/api/http-client";
import { MONTHLY_SUMMARY_QUERY_KEY } from "./constants";
import type { MonthlySummary } from "./types";

/**
 * Hand-written fetch — see CLAUDE.md → TD-07. `GET /api/admin/financial/
 * monthly-summary?month=YYYY-MM` (API-FIN-6), read tier ADMIN + FINANCE.
 * Disabled until a month is chosen. Amounts are USD cents (single-currency MVP).
 */
export function useMonthlySummary(month: string) {
  return useQuery({
    queryKey: [...MONTHLY_SUMMARY_QUERY_KEY, month] as const,
    queryFn: () =>
      httpClient<MonthlySummary>(
        `/api/admin/financial/monthly-summary?month=${encodeURIComponent(month)}`,
      ),
    enabled: month.length > 0,
    placeholderData: keepPreviousData,
    staleTime: 60_000,
  });
}
